import type { ReactNode } from 'react'

export type ProNoticePanelProps = {
  testId: string
  icon: ReactNode
  heading: string
  description: string
  storeUrl?: string
  storeLinkLabel?: string
}

export function ProNoticePanel({
  testId,
  icon,
  heading,
  description,
  storeUrl,
  storeLinkLabel,
}: ProNoticePanelProps) {
  return (
    <div className="flex flex-col gap-4 rounded-xl border p-5 text-center" data-testid={testId}>
      <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-primary/15 text-primary">
        {icon}
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold text-foreground">{heading}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      {storeUrl && storeLinkLabel ? (
        <a
          href={storeUrl}
          rel="noreferrer"
          data-testid="pro-manage-in-store"
          className="w-full rounded-lg bg-primary px-4 py-3.5 text-base font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
        >
          {storeLinkLabel}
        </a>
      ) : null}
    </div>
  )
}
